import { useQuery } from 'react-query';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { makeFetchCustomerByIdUseCase } from 'modules/customer/domain/useCases';
import { customerQueries } from 'modules/customer/presentation/constants';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

export default function useCustomer() {
  const auth = useAuth();
  const { handleError } = useRequestErrorHandler('customer');

  const query = useQuery(
    customerQueries.customer(auth.session?.id),
    () => {
      if (!auth.session) throw new Error();

      return makeFetchCustomerByIdUseCase().execute({ id: auth.session.id });
    },
    {
      enabled: !!auth.session,
      onError: handleError,
    },
  );

  return {
    loading: query.isLoading,
    customer: query.data || null,
  };
}
